import { render, staticRenderFns } from "./ChangePackage.vue?vue&type=template&id=8f1a4008&"
import script from "./ChangePackage.vue?vue&type=script&lang=js&"
export * from "./ChangePackage.vue?vue&type=script&lang=js&"
import style0 from "./ChangePackage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports